import { render, staticRenderFns } from "./XFormGroup.vue?vue&type=template&id=6d1208a7&"
import script from "./XFormGroup.vue?vue&type=script&lang=js&"
export * from "./XFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./XFormGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports